module.exports = __webpack_public_path__ + "static/media/checked-black.1834eb07.svg";